import { createClient } from '@sanity/client';

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
const dataset = process.env.REACT_APP_SANITY_DATASET;
const apiVersion = process.env.REACT_APP_SANITY_API_VERSION || '2026-05-11';
const useCdn = process.env.REACT_APP_SANITY_USE_CDN;

export const hasSanityConfig = Boolean(projectId && dataset);

const sanityClient = hasSanityConfig
    ? createClient({
        projectId,
        dataset,
        apiVersion,
        useCdn,
    })
    : null;

export const sanityConfig = {
    apiVersion,
    dataset,
    projectId,
    useCdn,
};

export default sanityClient;